import { useSelector } from 'react-redux';
import {
  getDistanceUnitSelector,
  getElevationUnitSelector,
} from 'store/Common/selectors';
import { Tooltip } from 'antd';

import { S } from './RouteCard.styles';
import { RouteCardProps } from './RouteCard.inteface';
import { FormattedMessage, useIntl } from 'react-intl';
import { BaseSwitch } from 'controls/BaseSwitch/BaseSwitch';
import { MenuButton } from 'shared/Buttons/MenuButton/MenuButton';
import { getTotalGrade } from 'utils/plannedRoutesHelper';


export const RouteCard: React.FC<RouteCardProps> = ({
  route,
  onRouteChanged,
  onMenuButtonClick
}) => {
  const actualDistanceUnit = useSelector(getDistanceUnitSelector);
  const actualElevationUnit = useSelector(getElevationUnitSelector);

  let intl = useIntl()

  const routeName = route.routeName ? route.routeName : `[${intl.formatMessage({id:"untitled"})}]`;

  const handleChange = (checked: boolean) => {
      if (onRouteChanged){
        onRouteChanged(route, checked)
      }
  };

  const handleShowContextMenu = (event: React.MouseEvent<HTMLElement>) => {
    onMenuButtonClick(event, route);
  };

  return (
    <S.Container>
      <S.RouteInfo>
        <Tooltip placement="top" title={routeName}>
          <S.Title>{routeName}</S.Title>
          <S.Description>{route.routeDescription}</S.Description>
        </Tooltip>
        <S.ShortInfo>
            {(route.routeLength || route.routeLength === 0) && (
              <S.Li>
                {(route.routeLength / actualDistanceUnit.valueInMeters).toFixed(1)}{' '}
                <FormattedMessage id={actualDistanceUnit.name}/>
              </S.Li>
            )}
              
            <FormattedMessage id="total_grade"/>:{' '}
            {getTotalGrade(route, actualDistanceUnit, actualElevationUnit).toFixed(0)}{' '}
            <FormattedMessage id={actualElevationUnit.shortName}/>
          <br/>
          <S.Li>
            <FormattedMessage id="total_asc"/>:{' '}
            {(route.totalAscent / actualElevationUnit.valueInMeters).toFixed(0)}{' '}
            <FormattedMessage id={actualElevationUnit.shortName}/>
          </S.Li>
          <S.Li>
            <FormattedMessage id="total_desc"/>:{' '}
            {(route.totalDescent / actualElevationUnit.valueInMeters).toFixed(0)}{' '}
            <FormattedMessage id={actualElevationUnit.shortName}/>
          </S.Li>
        </S.ShortInfo>
        {/* <S.Location>{name}</S.Location> */}
      </S.RouteInfo>
      <S.Sidebar>
        <BaseSwitch
          onChange={handleChange}
          checked={route.isEnabled}
        />
        <MenuButton onClick={handleShowContextMenu} />
      </S.Sidebar>
    </S.Container>
  );
};
